import { useNavigate } from '@tanstack/react-router';
import { contentCreatorRoutes } from '@/constants/routes/app';
import { TContentType } from '@/types/Content.types';
import ContentTypePicker from '@/modules/content/creation/ContentTypePicker';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

// Lets the creator pick a content type, then routes into the creation wizard.
const CreateContentModal = ({ isOpen, onClose }: Props) => {
  const navigate = useNavigate({ from: contentCreatorRoutes.creatorProfile });

  const handleSelect = (type: TContentType) => {
    onClose();
    navigate({ to: contentCreatorRoutes.creatorContentCreate, search: { type } });
  };

  return <ContentTypePicker isOpen={isOpen} onClose={onClose} onSelect={handleSelect} />;
};

export default CreateContentModal;
